import { Component, OnInit } from '@angular/core';
import {LanguageService} from 'projects/library/src/services/language/language.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    languageService: LanguageService
  ) { }

  ngOnInit(): void {
  }

}
